// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3i4kS","largestCol":"styles_largestCol__2ECGf","smallestCol":"styles_smallestCol__32_gY"};